<template>
  <div class="utc-wrapper">
    <span class="mr-10">{{ $t('text.utc_offset') }}</span>
    <el-select
      class="utc-select"
      v-model="utcOffset"
      size="small"
      :placeholder="$t('text.please_select')"
      @change="handleUtcChange()"
      filterable
    >
      <el-option
        v-for="item in utcOffsetOptions"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
  </div>
</template>

<script>
import { utcOffsets } from '../const'
export default {
  data() {
    return {
      utcOffsetOptions: utcOffsets,
      utcOffset: this.$store.state.pods.selectedUtcOffset
    }
  },
  watch: {
    '$store.state.pods.selectedUtcOffset': function() {
      this.utcOffset = this.$store.state.pods.selectedUtcOffset
    }
  },
  methods: {
    handleUtcChange() {
      this.$store.commit('pods/SET_SELECTED_UTC_OFFSET', this.utcOffset)
    }
  }
}
</script>
